import React, { useState } from "react";
import OrganizationTab from "./OrganizationTab";
/* import ProjectsTab from "../reusableComponents/ProjectsTab/ProjectsTab"; */
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "./DonationsHistoryTabs.css";
import DonorsHistoryTab from "./DonorsHistoryTab";
import * as helper from "../../global/helpers";

const DonationsHistoryTabs = (props) => {
    const [tabIndex, setTabIndex] = useState(0);
    return (
        <Tabs
            selectedIndex={tabIndex}
            onSelect={tabIndex => setTabIndex(tabIndex)}
            className="donations_tabs"
        >
            <TabList>
                <Tab>Organization</Tab>
            </TabList>
            <TabPanel>
                {helper.isOrg() ? <DonorsHistoryTab/> : <OrganizationTab/>}
            </TabPanel>
        </Tabs>
    );
};

export default DonationsHistoryTabs;
